import { render, staticRenderFns } from "./ConnectDirectoryEditPageDynamic.vue?vue&type=template&id=2fb3ff2e"
import script from "./ConnectDirectoryEditPageDynamic.vue?vue&type=script&lang=js"
export * from "./ConnectDirectoryEditPageDynamic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports